<template>
  <div class="whitebox review-box p-2 mb-1">
    <StarRatingWithAvg :score="averageScore" :reviewCount="reviewCount" />
    <CustomerReview
      v-if="featuredReviews[currentReview]"
      :review="featuredReviews[currentReview]"
      @mouseenter="setScroll(false)"
      @mouseleave="setScroll(true)"
      class="customer-review"
    />
  </div>
</template>

<script setup>
import { useCountryStore } from "~~/stores/country";
import { useReviewStore } from "~~/stores/review";

const reviewStore = useReviewStore();
const countryStore = useCountryStore();

const featuredReviews = computed(() => {
  return reviewStore.featuredReviews;
});

const currentReview = ref(0);
const maxReviews = computed(() => Math.min(featuredReviews.value.length, 3));
const isScrollStopped = ref(false);

const setScroll = (value) => {
  isScrollStopped.value = !value;
};

const averageScore = computed(() => {
  const scores = reviewStore.reviewSummary.scoreSummary;
  let count = 0;
  let sum = 0;
  for (const score in scores) {
    count += scores[score];
    sum += scores[score] * parseInt(score);
  }
  if (sum / count) {
    return sum / count;
  } else {
    return 0;
  }
});

const reviewCount = computed(() => {
  const scores = reviewStore.reviewSummary.scoreSummary;
  let count = 0;
  for (const score in scores) {
    count += scores[score];
  }
  if (count) {
    return count;
  } else {
    return 0;
  }
});

const startReviewScroll = () => {
  setInterval(() => {
    if (!isScrollStopped.value) {
      if (currentReview.value + 1 >= maxReviews.value) {
        currentReview.value = 0;
      } else {
        ++currentReview.value;
      }
    }
  }, 4000);
};

onMounted(function () {
  try {
    reviewStore.fetchReviewSummary();
    reviewStore.fetchFeaturedReviews(countryStore.countryId);
  } catch (err) {
    console.error(err);
  }
  startReviewScroll();
});
</script>

<style scoped lang="scss">
.review-box {
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: stretch;
  height: 116px;
  overflow: hidden;
}

@media only screen and (max-width: 885px) {
  .review-box {
    flex-direction: column;
    gap: 16px;
    height: 185px;

    .customer-review {
      flex: 100;
    }
  }
}
</style>
